export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M3.25 4A.75.75 0 014 3.25h13a.75.75 0 010 1.5H4A.75.75 0 013.25 4zM3.25 8A.75.75 0 014 7.25h8a.75.75 0 010 1.5H4A.75.75 0 013.25 8zM3.25 12a.75.75 0 01.75-.75h8a.75.75 0 010 1.5H4a.75.75 0 01-.75-.75zM3.25 16a.75.75 0 01.75-.75h8a.75.75 0 010 1.5H4a.75.75 0 01-.75-.75zM3.25 20a.75.75 0 01.75-.75h13a.75.75 0 010 1.5H4a.75.75 0 01-.75-.75z\" fill=\"#6F7488\"/><path d=\"M17 15l3-3-3-3v6z\" fill=\"#6F7488\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M16.713 15.693A.75.75 0 0116.25 15V9a.75.75 0 011.28-.53l3 3a.75.75 0 010 1.06l-3 3a.75.75 0 01-.817.163zm1.037-2.504L18.94 12l-1.19-1.19v2.38z\" fill=\"#6F7488\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};